import React from 'react';
import { Flame, Skull } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="relative bg-black border-t-2 border-red-900/30 py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <Flame className="w-8 h-8 text-red-600" />
              <div>
                <h3 className="text-2xl font-black text-white tracking-wider">RASPUTIN</h3>
                <p className="text-xs text-yellow-500 font-semibold tracking-widest">MOLHO PICANTE</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm">
              O molho mais intenso que você já experimentou. Feito para os verdadeiros amantes de pimenta.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-black mb-4 tracking-wider">NAVEGAÇÃO</h4>
            <ul className="space-y-2">
              <li>
                <a href="#about" className="text-gray-400 hover:text-red-500 transition-colors duration-300 text-sm">
                  Sobre o Produto
                </a>
              </li>
              <li>
                <a href="#intensity" className="text-gray-400 hover:text-red-500 transition-colors duration-300 text-sm">
                  Medidor de Intensidade
                </a>
              </li>
              <li>
                <a href="#gallery" className="text-gray-400 hover:text-red-500 transition-colors duration-300 text-sm">
                  Galeria
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-red-500 transition-colors duration-300 text-sm">
                  Contato
                </a>
              </li>
            </ul>
          </div>

          {/* Warning */}
          <div>
            <h4 className="text-white font-black mb-4 tracking-wider">AVISO</h4>
            <div className="bg-red-950/30 border-2 border-red-600 rounded-lg p-4">
              <div className="flex items-start gap-3">
                <Skull className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" />
                <p className="text-gray-300 text-sm leading-relaxed">
                  Produto extremamente picante. Use com moderação. Mantenha fora do alcance de crianças.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-red-900/30 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-sm">
              © {new Date().getFullYear()} Rasputin Molho Picante. Todos os direitos reservados.
            </p>
            <div className="flex items-center gap-2 text-gray-500 text-sm">
              <Flame className="w-4 h-4 text-red-600" />
              <span>Feito com fogo e paixão</span>
              <Flame className="w-4 h-4 text-red-600" />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
